require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-est-living-m-residence.json") })
        }
      }, "path---journal-est-living-m-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-est-living-m-residence!./.cache/json/journal-est-living-m-residence.json
// module id = 486
// module chunks = 231608221292675